import React from 'react'
import { faPlus, faXmark } from '@fortawesome/free-solid-svg-icons'

import ProfileSection from 'app/common/pixel-menu/_comp/ProfileSection'
import {
  $DCprimaryColor,
  DcBreadcrumbs,
  DcButton,
  DcDiv,
  DcFlexBox,
  DcIcon,
  DcInput,
  DcOverlaySlider,
  PixelIcon,
  PixelModal,
  PixelPageContainer,
  PixelTable,
  Section,
  SectionContent,
} from 'pixel-base'
import styled from 'styled-components'
import { get, getCustomers } from 'utils/api-routes.util'

import AddNewCustomer from './details/components/AddNewCustomer'
import CustomerDetails from './details/CustomerDetails'

const breadcrumbs = [
  {
    name: 'Customers',
    active: true,
  },
]
const columns = [
  {
    dataKey: 'customer_id',
    name: 'ID #',
    sortable: true,
    selector: (row) => row.customer_id || '--',
  },
  {
    dataKey: 'full_name',
    name: 'Customer',
    sortable: true,
    selector: (row) =>
      (
        <CustomerInfo>
          {row.first_name} {row.last_name}
        </CustomerInfo>
      ) || '--',
  },
  {
    dataKey: 'company',
    name: 'Company Name',
    sortable: true,
    selector: (row) => row.company || '--',
  },
  {
    dataKey: 'email',
    name: 'Email',
    sortable: true,
    selector: (row) => <CustomerInfo>{row.email}</CustomerInfo> || '--',
  },
  {
    dataKey: 'phone',
    name: 'Phone',
    sortable: true,
    selector: (row) => row.phone || '--',
  },
  {
    dataKey: 'customer_reference',
    name: 'Reference',
    sortable: true,
    selector: (row) => row.customer_reference || '--',
  },
  {
    dataKey: 'balance',
    name: 'Balance Due',
    sortable: true,
    selector: (row) => row.balance,
  },
]

const Customer = () => {
  const [customers, setCustomers] = React.useState<any>([])
  const [tableLoading, setTableLoading] = React.useState(false)
  const [showModal, setShowModal] = React.useState(false)
  const [customerId, setCustomerId] = React.useState(null)
  const [showDetailModal, setShowDetailModal] = React.useState(false)
  const [totalRows, setTotalRows] = React.useState(0)
  const [perPage, setPerPage] = React.useState(25)
  const [countries, setCountries] = React.useState({
    list: [],
    default: '',
  })

  const handlePageChange = (page, perPage) => {
    setPerPage(perPage)
    getAllCustomers(page)
  }

  const handlePerRowsChange = async (newPerPage, page) => {
    getAllCustomers(page, newPerPage)
  }

  const getAllCustomers = (page, newPerPage?, search?) => {
    setTableLoading(true)
    getCustomers({
      page: page - 1 || 0,
      perPage: newPerPage || perPage,
      search: search,
    }).subscribe((res: any) => {
      setCustomers(res.response.data)
      setTotalRows(res.response._meta.total)
      setTableLoading(false)
    })
  }

  React.useEffect(() => {
    getAllCountries()
  }, [])
  const getAllCountries = () => {
    get('/settings/options/countries').subscribe((res: any) => {
      setCountries({
        list: res.response.data,
        default: res.response._meta?.default,
      })
    })
  }
  const onRowClicked = (row: any) => {
    // navigate(`/customers/${row.customer_id}`)
    setCustomerId(row.customer_id)
    setShowDetailModal(true)
  }

  const [filterText, setFilterText] = React.useState('')
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false)

  React.useEffect(() => {
    getAllCustomers(1, perPage, filterText)
  }, [filterText])

  return (
    <>
      <DcFlexBox
        height="60px"
        fontSize="16px"
        style={{
          fontSize: '16px',
          padding: '8px 0px',
          borderBottom: '1px solid #e5e5e5',
        }}
      >
        <DcFlexBox
          justifyContent="space-between"
          alignItems="center"
          padding=".5rem 20px"
        >
          <DcBreadcrumbs fontSize="16px" data={breadcrumbs} />

          <ProfileSection />
        </DcFlexBox>
      </DcFlexBox>

      <PixelPageContainer style={{ padding: '0' }}>
        <Section style={{ padding: '0px' }}>
          <SectionContent style={{ padding: '0px', borderRadius: '0px' }}>
            <DcFlexBox
              justifyContent="flex-end"
              height="auto"
              padding=" 5px 20px"
              gap="5px"
            >
              <SearchPixelInput>
                <DcInput
                  inputSize="small"
                  showsearchicon={0}
                  placeholder="Search"
                  name="search"
                  onChange={(e) => {
                    setResetPaginationToggle(e.target.value.length > 0)
                    setFilterText(e.target.value)
                  }}
                  value={filterText}
                />
              </SearchPixelInput>
              <DcButton size="sm" onClick={() => setShowModal(true)}>
                <PixelIcon color="#fff" icon={faPlus} /> Add New
              </DcButton>
            </DcFlexBox>
          </SectionContent>
        </Section>
        <Section style={{ padding: '20px' }}>
          <SectionContent>
            <PixelTable
              highlightOnHover={true}
              // isSearchable={true}
              pointerOnHover={true}
              columns={columns}
              data={customers}
              progressPending={tableLoading}
              paginationServer
              paginationTotalRows={totalRows}
              onChangeRowsPerPage={handlePerRowsChange}
              // subHeaderComponent={subHeaderComponentMemo}
              paginationResetDefaultPage={resetPaginationToggle}
              onChangePage={handlePageChange}
              onRowClicked={onRowClicked}
              fixedHeader={true}
              fixedHeaderScrollHeight="calc(100vh - 211px)"
            />
          </SectionContent>
        </Section>
      </PixelPageContainer>

      {showModal && (
        <DcOverlaySlider
          title={'Add Customer'}
          width={'40%'}
          onClose={() => setShowModal(false)}
          isOpen={showModal}
        >
          {showModal && (
            <AddNewCustomer
              countries={countries}
              handleClose={(data) => {
                onRowClicked(data)
                {
                  showModal && (
                    <AddNewCustomer
                      countries={countries}
                      handleClose={(data) => {
                        onRowClicked(data)
                        setShowModal(false)
                      }}
                    />
                  )
                }
                setShowModal(false)
              }}
            />
          )}
        </DcOverlaySlider>
      )}

      <DcOverlaySlider
        title={'Customer Details'}
        onClose={() => setShowDetailModal(false)}
        isOpen={showDetailModal}
        padding="0"
      >
        <CustomerDetails
          customer_id={customerId}
          setShowDetailModal={setShowDetailModal}
        />
      </DcOverlaySlider>
    </>
  )
}

const CustomerInfo = styled.div`
  white-space: break-spaces !important;
`
const SearchPixelInput = styled.div`
  width: 30%;
`
export default Customer
